import { Rules } from '../components/insurance/Rules';

export const InsuranceRulesContainer = Rules;
